var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashback-description grid"},[_c('div',{staticClass:"cell cell--9-col cell--12-col-tablet "},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("cashbackDesc.p1"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("cashbackDesc.p2"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }